export default __webpack_public_path__ + "static/media/dots_circle_disabled.ddea6e55.png";